export default [
  {
    path: '/2023/report/doc',
    component: () => import('./views/report/doc')
  },
  {
    path: '/2023/report/login',
    component: () => import('./views/report/login.vue')
  },
  {
    path: '/2023/report/index',
    component: () => import('./views/report/index.vue')
  }
]



// WEBPACK FOOTER //
// ./src/page/2023/route.js